<template>
  <div class="plv-iar-payment-methods pws-iar-payment-methods">
    <div class="plv-iar-payment-title">{{ iarTrans('product.paymentMethod') }}</div>
    <div class="plv-iar-payment-list">
      <div
        v-for="(method, index) in realPaymentMethods"
        :key="index"
        class="plv-iar-payment-item"
        @click="selectPaymentMethod(method.value)"
      >
        <div class="plv-iar-payment-info">
          <div class="plv-iar-payment-icon">
            <img :src="method.src" alt="icon" />
          </div>
          <span class="plv-iar-payment-label">{{ method.label }}</span>
        </div>
        <plv-radio
          :checked="selectedMethod === method.value"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import '@polyv/polyv-ui/lib-admin/theme/radio.css';
import PlvRadio from '@polyv/polyv-ui/lib-admin/radio';
import { PAYMENT_METHODS } from './const';
import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/product';

export default {
  langs,

  name: 'PaymentMethods',

  components: {
    'plv-radio': PlvRadio
  },

  mixins: [entryMixin],

  props: {
    /**
     * 默认选中的支付方式
     */
    value: {
      type: String,
      default: PAYMENT_METHODS.WECHAT
    },

    /**
     * 自定义支付方式
     */
    paymentMethods: {
      type: Array,
      default: () => []
    },

    /**
     * 排除的支付方式
     */
    excludePaymentMethods: {
      type: Array,
      default: () => []
    },

    /**
     * 是否禁用支付方式
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    realPaymentMethods() {
      if (this.paymentMethods.length > 0) {
        return this.paymentMethods;
      }

      const excludePaymentMethods = this.excludePaymentMethods;

      return this.innerPaymentMethods.filter(method => !excludePaymentMethods.includes(method.value)).map(method => ({
        ...method,
        iconComponent: method.iconComponent
      }));
    },

    innerPaymentMethods() {
      return [
        {
          label: this.iarTrans('product.paymentMethodWechat'),
          value: PAYMENT_METHODS.WECHAT,
          src: require('./images/icon-wechat.svg')
        },
        {
          label: this.iarTrans('product.paymentMethodAlipay'),
          value: PAYMENT_METHODS.ALIPAY,
          src: require('./images/icon-alipay.svg')
        }
      ];
    }
  },

  data() {
    return {
      selectedMethod: this.value,
    };
  },

  watch: {
    value(newVal) {
      this.selectedMethod = newVal;
    }
  },

  methods: {
    selectPaymentMethod(method) {
      if (this.disabled) {
        return;
      }

      this.selectedMethod = method;
      this.$emit('input', method);
      this.$emit('change', method);
    }
  }
};
</script>

<style lang="scss">
// @import '@polyv/polyv-ui/lib-admin/theme/radio.css';

.plv-iar-payment-methods {
  padding: 10px 12px;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 8px;
}

.plv-iar-payment-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
}

.plv-iar-payment-list {
  display: flex;
  flex-direction: column;
}

.plv-iar-payment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.plv-iar-payment-info {
  display: flex;
  align-items: center;
}

.plv-iar-payment-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plv-iar-payment-label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}
</style>
